import React from "react";
import styles from "./XmbFond.module.css";
import {resoudre} from "../reglages";
import {REGLAGES} from "./reglages";
import {HAUTEUR, PERIODE, chemin, ruban} from "./rubans";
import {THEMES, themeChoisi} from "./themes";

/*
 * Fond « Vague » : de longs rubans de soie translucides qui ondulent lentement sur un dégradé de couleur, dans l'esprit du
 * menu des consoles de salon et portables de Sony. Dessin et code originaux (aucune image, aucun élément de Sony).
 * Chaque ruban est une forme SVG (rubans.js, testé : le tracé se répète sans raccord) qui glisse d'une période en boucle, avec en
 * plus une lente houle verticale : deux déplacements transform par ruban, rien d'autre ne bouge.
 * La couleur suit le mois (comme le menu d'origine) ou se choisit. Réglages (reglages.js) : couleur, vitesse, nombre de rubans.
 */

export default function XmbFond({reglages}) {
    const {theme, vitesse, rubans} = resoudre(REGLAGES, reglages);
    // « automatique » se recalcule à chaque affichage du bandeau (une fois par seconde) : le thème change avec le mois
    const nom = themeChoisi(theme, new Date());
    const t = THEMES[nom];
    const idDegrade = "xmb-degrade-" + nom;

    return (
        <div className={styles.scene} aria-hidden="true" style={{background: `linear-gradient(180deg, ${t.haut} 0%, ${t.bas} 100%)`, "--bas": t.bas}}>
            <svg width="0" height="0" className={styles.defs}>
                <defs>
                    <linearGradient id={idDegrade} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0" stopColor={`rgb(${t.ruban})`} stopOpacity="0"/>
                        <stop offset="0.5" stopColor={`rgb(${t.ruban})`} stopOpacity="0.95"/>
                        <stop offset="1" stopColor={`rgb(${t.ruban})`} stopOpacity="0"/>
                    </linearGradient>
                </defs>
            </svg>
            {Array.from({length: rubans}, (_, i) => {
                const p = ruban(i, rubans);
                return (
                    <div key={i} className={styles.houle} style={{"--houle": `${p.amplitudeHoule.toFixed(1)}px`, animationDuration: `${(p.houle / vitesse).toFixed(2)}s`, animationDelay: `${(-i * 1.7).toFixed(1)}s`}}>
                        <svg
                            className={styles.derive}
                            viewBox={`0 0 ${PERIODE * 2} ${HAUTEUR}`}
                            preserveAspectRatio="none"
                            style={{animationDuration: `${(p.derive / vitesse).toFixed(1)}s`, animationDelay: `${(-i * 5.3).toFixed(1)}s`}}
                        >
                            <path d={chemin(p, 2)} fill={`url(#${idDegrade})`} opacity={p.opacite.toFixed(2)}/>
                        </svg>
                    </div>
                );
            })}
        </div>
    );
}
